<div class="app-wrapper logo-org" *ngIf="access; else noOrgProfileAccess" [ngClass]="{'with-overlay': showLogoEditor || ((errorActions$ | async) || (modalView !== MODAL_VIEW_NONE))}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === MODAL_VIEW_LOGO_UPLOAD_SUCCESS"
        [type]="'done'"
        [message]="'Organization Profile Saved'"
        [text]="'Your organization profile has been successfully updated'"
        [buttonText]="'Done'"
        (action)="onSavedDone($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback 
      class="modal-feedback" 
      *ngIf="modalView === MODAL_VIEW_LOGO_UPLOAD_ERROR && (errorActions$ | async) as error"
      [type]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'warning': 'fail'"
      [message]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'Forbidden': 'Error'"
      [text]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 
            'The organization logo could NOT be updated. Please contact your admin for additional support.': 
            'Something went wrong updating your organization logo. Please review your data or reload the editor to try again. If the error persists, please reach out to our support team through the Help Me button.'"
      [buttonText]="'OK'"
      (action)="onError($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback 
      class="modal-feedback" 
      *ngIf="modalView === MODAL_VIEW_ORGANIZATION_UPDATE_ERROR && (errorActions$ | async) as error" 
      [type]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'warning': 'fail'"
      [message]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'Forbidden': 'Error'"
      [text]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 
            'The organization could NOT be updated. Please contact your admin for additional support.': 
            'Something went wrong updating your organization. Please review your data or reload the editor to try again. If the error persists, please reach out to our support team through the Help Me button.'"
      [buttonText]="'OK'"
      (action)="onError($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback 
      class="modal-feedback" 
      *ngIf="modalView === MODAL_VIEW_LOGO_DELETE_ERROR && (errorActions$ | async) as error" 
      [type]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'warning': 'fail'"
      [message]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 'Forbidden': 'Error'"
      [text]="( error && error.status === RESPONSE_ERROR_FORBIDDEN)? 
            'The organization logo could NOT be removed. Please contact your admin for additional support.': 
            'Something went wrong deleting your organization logo. Please review your data or reload the editor to try again. If the error persists, please reach out to our support team through the Help Me button.'"
      [buttonText]="'OK'"
      (action)="onError($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback modal-feedback-success" *ngIf="modalView == MODAL_VIEW_ORGANIZATION_UPDATE_ERROR"
      [type]="'success'"
      [message]="'Success'"
      [text]="'Your organization’s details have been saved.'"
      [buttonText]="'Ok'"
      (action)="onSuccess($event)">
    </core-layout-modal-feedback>
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content org-profile org-profile-section" *ngIf="status == STATUS_DONE" >
        <div class="app-main">
            <header>
                <div class="data-header">
                    <core-title-section
                    [title]="'Organization Profile'"
                    [description]="'You can configure a name and logo for your account. The logo will be used in all email templates.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                </div>
            </header>

              <div class="profile-edit-container box_default box_white" >
                <header>
                  <h3>ORGANIZATION DETAILS</h3>
                </header>
                  <div class="organization-profile-logo" title="Click to edit logo" (click)="openLogoEditor()">
                    <figure>
                      <organization-profile-logo-img *ngIf="!working; else logoLoading" [organization]="organization" [width]="300"></organization-profile-logo-img>
                      <ng-template #logoLoading><core-helpers-box-loading [hidden]="loaded"></core-helpers-box-loading></ng-template>
                      <span></span>
                    </figure>
                  </div>
                    <form [formGroup]="form">
                      <div class="box_item">
                        <label class="box-label">NAME</label>
                          <input type="text" placeholder="Introduce your name." formControlName="name"/>
                      </div>
                      <div class="box_fieldset">
                        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid || !formChanged()" (click)= "save()"></core-helpers-forms-button-white>
                      </div>
                    </form>
              </div>
        </div>
    </section>
    <organization-profile-logo-main *ngIf="showLogoEditor" 
          [org]="organization" 
          [logo]="logo" 
          (clickCancel)="closeLogoEditor()"
          (clickSave)="setLogoWorking()"
          ></organization-profile-logo-main>
</div>

<ng-template #noOrgProfileAccess>
  <core-helpers-box-http-error [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
</ng-template>
